import { render, staticRenderFns } from "./DocumentState.vue?vue&type=template&id=31be046f&scoped=true"
import script from "./DocumentState.vue?vue&type=script&lang=js"
export * from "./DocumentState.vue?vue&type=script&lang=js"
import style0 from "./DocumentState.vue?vue&type=style&index=0&id=31be046f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be046f",
  null
  
)

export default component.exports